import React from 'react';
import { TextField, Typography } from '@scale/scaleui';
import { MultiTurnInteractionConfiguration, InteractionStepType } from '@scale/shared/types/chat';

interface NumberOfTurnsProps {
  value: MultiTurnInteractionConfiguration;
  onSubmit: (config: MultiTurnInteractionConfiguration) => void;
  parseTurnsAmount: (value: string) => string | number;
}

const NumberOfTurns = ({ value, onSubmit, parseTurnsAmount }: NumberOfTurnsProps) => {
  return (
    <div className="flex flex-col gap-2">
      <Typography.H3>Number of Turns</Typography.H3>
      <Typography.Paragraph2 color="text-neutral-500">
        Restricts the number of turns (prompt-response pairs) that a tasker can make during a single
        chat session. Note that the “Before steps” and “After steps” will only run once, no matter
        the number of turns.
      </Typography.Paragraph2>

      <TextField
        id="minTurns"
        label="Min Turns (default 1)"
        placeholder="1"
        value={value.minTurns}
        onChange={e => onSubmit({ ...value, minTurns: parseTurnsAmount(e.target.value) })}
      />
      <TextField
        id="maxTurns"
        label="Max Turns (default 100)"
        placeholder="100"
        value={value.maxTurns}
        onChange={e => onSubmit({ ...value, maxTurns: parseTurnsAmount(e.target.value) })}
      />
      {/* if there exists a ProcessSupervision step, or an ExperimentalToolUse step, then show a maxProcesses config that defaults to 1, explain that this is the number of possible processes that can be completed before the chat ends */}
      {value.turn.some(step => step.type === InteractionStepType.ProcessSupervision) && (
        <TextField
          id="maxProcessSupervisions"
          label="Max Process Supervisions (default 1)"
          placeholder="1"
          value={value.maxProcessSupervisions}
          onChange={e => onSubmit({ ...value, maxProcessSupervisions: parseInt(e.target.value) })}
        />
      )}
    </div>
  );
};

export default NumberOfTurns;
